var _path, _g, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiatCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.3478 16.75H11.6522C9.84208 16.75 8.375 22.3738 8.375 29.3125V50.25H58.625V29.3125C58.625 22.3738 57.1579 16.75 55.3478 16.75Z",
    fill: "url(#paint0_linear_1429_5151)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bi_1429_5151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.8125 8.375H4.1875C1.87481 8.375 0 10.2498 0 12.5625V54.4375C0 56.7502 1.87481 58.625 4.1875 58.625H62.8125C65.1252 58.625 67 56.7502 67 54.4375V12.5625C67 10.2498 65.1252 8.375 62.8125 8.375Z",
    fill: "#F1F1F1",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8125 8.375H4.1875C1.87481 8.375 0 10.2498 0 12.5625V54.4375C0 56.7502 1.87481 58.625 4.1875 58.625H62.8125C65.1252 58.625 67 56.7502 67 54.4375V12.5625C67 10.2498 65.1252 8.375 62.8125 8.375Z",
    fill: "url(#paint1_linear_1429_5151)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1875 8.975H62.8125C64.7938 8.975 66.4 10.5812 66.4 12.5625V54.4375C66.4 56.4188 64.7938 58.025 62.8125 58.025H4.1875C2.20618 58.025 0.6 56.4188 0.6 54.4375V12.5625C0.6 10.5812 2.20618 8.975 4.1875 8.975Z",
    stroke: "url(#paint2_linear_1429_5151)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67 19.5654H0V31.5297H67V19.5654Z",
    fill: "url(#paint3_linear_1429_5151)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1429_5151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4992 38.708H7.17773V45.8866H33.4992V38.708Z",
    fill: "white",
    fillOpacity: 0.16
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_1429_5151",
    x: -24,
    y: -15.625,
    width: 115,
    height: 98.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1429_5151"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1429_5151",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1429_5151"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1429_5151",
    x: 7.17773,
    y: 38.708,
    width: 26.3213,
    height: 15.1787,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1429_5151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1429_5151",
    x1: 10.4687,
    y1: 23.45,
    x2: 63.9796,
    y2: 34.5981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AE6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1429_5151",
    x1: 2.79167,
    y1: 18.425,
    x2: 74.7678,
    y2: 31.7539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66FECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8940FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1429_5151",
    x1: 2.09375,
    y1: 10.6591,
    x2: 67,
    y2: 10.6591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69CFB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1429_5151",
    x1: 2.79167,
    y1: 21.9583,
    x2: 49.1763,
    y2: 58.0352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AE6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AE7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiatCreditCard);
export default __webpack_public_path__ + "static/media/fiat-credit-card.dd91dd9a2f9ae387418f8481adf91779.svg";
export { ForwardRef as ReactComponent };